import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from '../App.tsx';
import './index.css';
import { getBasePath } from '../constants.ts';
import { ErrorBoundary } from '../components/ErrorBoundary.tsx';

// Registro do Service Worker do PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const base = getBasePath();
    const cleanBase = base ? base.replace(/\/+$/, '') : '';
    const swUrl = cleanBase ? `${cleanBase}/sw.js` : '/sw.js';
    const swScope = cleanBase ? `${cleanBase}/` : './';

    navigator.serviceWorker.register(swUrl, { scope: swScope })
      .then((registration) => {
        console.log('PWA: Service Worker registrado com sucesso no escopo:', registration.scope);
      })
      .catch((err) => {
        console.log('PWA: Tentativa de registro relativo de Service Worker:', err);
        navigator.serviceWorker.register('sw.js').catch((e) => console.log('SW registration failed:', e));
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
